( function($) {
  $( document ).ready( function() {
		$( '.change-store-btn' ).on( 'click', function(e) {
			e.preventDefault();

			$.ajax( {
				url: 'https://api.ipregistry.co/?key=g2irk5oxbpd9crzr',
				dataType: "json",
				type: 'get',

				success: function( loc_data ) {
					let lat = loc_data.location.latitude;
					let lng = loc_data.location.longitude;

					$.ajax( {
						url: '/wp-admin/admin-ajax.php',
						type: 'post',
						data: {
							lat: lat,
							lng: lng,
							action: 'reset_choose_store_list',
						},

						success: function( data ) {
							$( ".store-grid-container" ).html( data );
						},

						error: function( err ) {
							console.log( err );

							$( ".store-grid-container" ).html( '<div class="data-error-container">' +
								'<p>Sorry, an internal issue has occurred.  Please refresh your browser and try again.</p>' +
							'</div>' );
						}
					} );
				},

				error: function( err ) {
					console.log( err );
					
					$( ".store-grid-container" ).html( '<div class="data-error-container">' +
						'<p>Sorry, we\'re unable to get a list of nearby locations for you.  Please refresh your browser and try again.</p>' +
					'</div>' );
				}
			} ); 

			$( '.raq-store-list-loader-container' ).attr( 'hidden' );
		} );



    var form 		 = $( "#locationFinder" );
    var errorMsg = $( ".error-msg" );
    
    $( "#getLocation" ).bind( "click touchstart", function() {
      form.submit();
    } );
        
    form.submit( function(e) {
      e.preventDefault();
      
      var formInput = $( "#mapSearch" );
    
      // front-end validation
      if( formInput.val() === "" || formInput.val() == null ) {
        errorMsg.html( "Please enter a city, address, or postal code." );
      }
      
      else {
				// display loader
        $( ".store-grid-container" ).html( 
					'<div class="raq-store-list-loader-container"><div class="dot-flashing"></div></div>'
				);
            
        // reset the error message
        errorMsg.html( '' );    
        
        // get the location text field value
        var loc 		 = formInput.val();
        var geocoder = new google.maps.Geocoder();

        geocoder.geocode( { 'address': loc }, function( results, status ) {
          if( status === google.maps.GeocoderStatus.OK ) {
    
            // preparing data for form posting
            var lat = results[0].geometry.location.lat();
            var lng = results[0].geometry.location.lng();
						// console.log( results );

            // ajax to repopulate the nearest store modules
            $.ajax( {
              url: '/wp-admin/admin-ajax.php',
              type: 'post',
              data: {
                lat: lat,
                lng: lng,
                action: 'reset_choose_store_list',
              },

              success: function( data ) {
								// add the new location list
                $( ".store-grid-container" ).html( data );
              }
            } );         
          }
          
          else {
            console.log( 'Geocode was not successful for the following reason: ' + status );
            
						errorMsg.html(
							"No results found.  Please enter a valid city, address, or postal code."
						);
          
            return;
          }
        } );

        // scroll the page down to bring the search results into full view
        $( 'html, body' ).animate( {
					scrollTop: $( ".choose-store-container" ).offset().top
        }, 250 );
      }
            
      return false;
    } );
  } );
} )( jQuery );
  